/**
 * @copyright Copyright 2020 Epic Systems Corporation
 * @file API to get the root-relative path for a file
 * @author Dustin Gage
 */

declare let __webpack_public_path__: string;

export function getRootRelativePath(localPath: string): string {
	const rootPath = __webpack_public_path__ ? __webpack_public_path__ : "";

	return `${rootPath}${localPath}`;
}
